export const consts = {
  whatsapp: "https://wa.me/+5548999733487?text=",
  perPage: 3,
}
